import { Injectable } from '@angular/core';
import { SetAllPositionsListConfig } from '@app/routes/index/all-positions/index/_actions';
import { ApiCommodityFamily } from '@app/infrastructure/api/models';
import { State, Selector, Action, StateContext } from '@ngxs/store';

export const CURRENT_ALL_POSITIONS_LIST_VERSION = 1;

interface AllPositionsListStateModel {
  version: number;
  commodityId?: string;
  commodityFamily?: ApiCommodityFamily;
}

export const ALL_POSITIONS_LIST_STATE_DEFAULTS: AllPositionsListStateModel = {
  version: CURRENT_ALL_POSITIONS_LIST_VERSION,
  commodityId: undefined,
  commodityFamily: undefined,
};

@State<AllPositionsListStateModel>({
  name: 'AllPositionsList',
  defaults: ALL_POSITIONS_LIST_STATE_DEFAULTS,
})
@Injectable()
export class AllPositionsListState {
  @Selector()
  static commodityId(state: AllPositionsListStateModel): string | undefined {
    return state.commodityId;
  }

  @Selector()
  static commodityFamily(state: AllPositionsListStateModel): ApiCommodityFamily | undefined {
    return state.commodityFamily;
  }

  @Action(SetAllPositionsListConfig)
  setAllPositionsListConfig(
    ctx: StateContext<AllPositionsListStateModel>,
    action: SetAllPositionsListConfig,
  ) {
    ctx.patchState({
      commodityId: action.config.commodityId,
      commodityFamily: action.config.commodityFamily,
    });
  }
}
